



import { defineComponent, PropType } from "@vue/composition-api";
import { Editor } from "@toast-ui/editor";
import type { EditorOptions, EditorType, EventMap, PreviewStyle } from "@toast-ui/editor";

export default defineComponent({
  name: "ToastUiEditor",
  props: {
    height: { type: String, default: "300px" },
    initialValue: { type: String, default: "" },
    initialEditType: { type: String as PropType<EditorType>, default: "markdown" },
    previewStyle: { type: String as PropType<PreviewStyle>, default: "vertical" },
    options: { type: Object as PropType<Partial<EditorOptions>> },
  },
  emits: ["load", "change", "caretChange", "focus", "blur", "keydown", "keyup"],
  data() {
    return {
      editor: null as Editor | null,
    };
  },
  computed: {
    eventOptions(): Partial<EventMap> {
      return {
        load: (...args: any[]) => this.$emit("load", ...args),
        change: () => this.$emit("change", this.editor?.getHTML()),
        caretChange: (...args: any[]) => this.$emit("caretChange", ...args),
        focus: (...args: any[]) => this.$emit("focus", ...args),
        blur: (...args: any[]) => this.$emit("blur", ...args),
        keydown: (...args: any[]) => this.$emit("keydown", ...args),
        keyup: (...args: any[]) => this.$emit("keyup", ...args),
      };

      // todo: add support for 2 more editor events ???
      // beforePreviewRender: (html: string) => string;
      // beforeConvertWysiwygToMarkdown: (markdownText: string) => string
    },
    computedOptions(): Partial<EditorOptions> {
      return {
        initialEditType: this.initialEditType,
        initialValue: this.initialValue,
        height: this.height,
        previewStyle: this.previewStyle,
        events: this.eventOptions,
        ...this.options,
      };
    },
  },
  watch: {
    previewStyle(newValue) {
      this.editor && this.editor.changePreviewStyle(newValue);
    },
    height(newValue) {
      this.editor && this.editor.setHeight(newValue);
    },
  },
  mounted() {
    const options = { ...this.computedOptions, el: this.$refs.toastuiEditorViewer as HTMLElement };

    this.editor = new Editor(options);
  },
});
